<template>
    <div>
        <a href="javascript:void(0)" :class="btnClass" @click="open" v-if="!hideButton">
            <slot name="button">{{label}}</slot>
        </a>

        <div class="position-absolute right-0">
            <modal ref="modal" :title="title" :close_on_focus="true">
                <slot></slot>
            </modal>
        </div>
    </div>
</template>

<script>
	import Modal from "../general_components/Modal";
	export default {
		name: "RiskAssessmentModal",
		components: {Modal},
		props: {
            label: {
                type: String,
                default: 'Changes'
            },
            title: {
                required: true,
                type: String
            },
            btnClass: {
                required: false,
                type: String,
                default: 'ml-2 d-flex'
            },
            hideButton: {
                type: Boolean,
                default: false
            }
        },

        methods: {
			open(){
                this.$refs.modal.openModal();
            },

            close(forced = false){
                this.$refs.modal.closeModal(this.$refs.modal, forced);
            }
        }
	}
</script>
